import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import invariant from "tiny-invariant";
const createContainer = portalProps => {
  const container = document.createElement("div");
  container.setAttribute("class", "lodestar-portal");
  //if there are other portalProps add them to the container
  if (portalProps && Object.keys(portalProps).length > 0) {
    Object.entries(portalProps).forEach(_ref => {
      let [key, value] = _ref;
      if (typeof value === "function") {
        const vanillaKey = key.replace(/^on/, "").toLowerCase();
        container.addEventListener(vanillaKey, value);
      } else if (typeof value === "string" || typeof value === "number") {
        container.setAttribute(key, value);
      }
    });
  }
  return container;
};
const getBody = () => {
  invariant(document && document.body, "cannot find document.body");
  return document.body;
};
const getPortalParent = () => {
  const parentElement = document.querySelector("body > .lodestar-portal-container");
  if (!parentElement) {
    const parent = document.createElement("div");
    parent.setAttribute("class", "lodestar-portal-container");
    parent.setAttribute("style", `display: flex;`);
    getBody().appendChild(parent);
    return parent;
  }
  return parentElement;
};
export const Portal = _ref2 => {
  let {
    children,
    appendTo: customContainerElement,
    zIndex,
    ...rest
  } = _ref2;
  const [container, setContainer] = useState(null);
  // Choose a container.
  useEffect(() => {
    const newContainer = customContainerElement || createContainer(rest);
    setContainer(newContainer);

    // If we are creating our own portal container element, manage it.
    // Otherwise assume nothing about the provided container element.
    if (!customContainerElement) {
      getPortalParent().appendChild(newContainer);
      return () => {
        // Don't forget to clean up! But there might not be anything
        // to clean up if there was a custom container provided.
        getPortalParent().removeChild(newContainer);
        // clean up parent element if there are no more portals.
        const portals = !!document.querySelector("body > .lodestar-portal-container > .lodestar-portal");
        if (!portals) {
          getBody().removeChild(getPortalParent());
        }
        if (Object.keys(rest).length > 0) {
          //remove any event listeners that might have been added to the container
          //via the portalProps
          Object.entries(rest).forEach(_ref3 => {
            let [key, value] = _ref3;
            if (typeof value === "function") {
              newContainer.removeEventListener(key, value);
            }
          });
        }
      };
    }
  }, [customContainerElement]); //eslint-disable-line react-hooks/exhaustive-deps

  // Sync the z-index to the chosen container.
  useEffect(() => {
    if (container) {
      // If we have a custom element, only set the z-index if it's specified, we don't
      // even want to set a z-index of 0 to the custom element if it's not asked for.
      if (customContainerElement && zIndex !== undefined || !customContainerElement) {
        container.style.zIndex = `${zIndex || 0}`;
      }
    }
  }, [container, zIndex, customContainerElement]);
  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
};
//# sourceMappingURL=Portal.js.map